import type { RouterRootContext } from '@/router'
import { GlobalErrorPage } from '@/components/ui/errors'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/login')({
  component: Outlet,
  errorComponent: GlobalErrorPage,
  beforeLoad: (ctx) => {
    const context = ctx.context as RouterRootContext
    if (context.isAuthenticated) throw redirect({ to: (ctx.search as any).next || '/' })
  },
})
